import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  isBackendError: boolean = false;
  isSubdomainUnavailable: boolean = false;
  homeRoute: string = '/';

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    // Check if this is a backend connection error and compute where home/retry should go.
    this.route.queryParams.subscribe(params => {
      this.isBackendError = params['error'] === 'backend-disconnected';
      this.isSubdomainUnavailable = params['error'] === 'subdomain-unavailable';
      const isPortalFromQuery = params['home'] === '/portal';

      const navigationState = this.router.getCurrentNavigation()?.extras?.state || history.state;
      const routeFromState = navigationState?.fromUrl || '';
      const homeFromState = navigationState?.homeRoute || '';
      const homeFromStorage = window.sessionStorage.getItem('errorHomeRoute') || '';
      const previousVisitedUrl = window.sessionStorage.getItem('previousVisitedUrl') || '';
      const isPortalFromUrl = this.router.url.includes('/portal');
      const isPortalFromState = routeFromState.includes('/portal') || homeFromState === '/portal';
      const isPortalFromStorage = homeFromStorage === '/portal';
      const isPortalFromPreviousUrl = previousVisitedUrl.includes('/portal');

      this.homeRoute =
        isPortalFromQuery ||
        isPortalFromUrl ||
        isPortalFromState ||
        isPortalFromStorage ||
        isPortalFromPreviousUrl
          ? '/portal'
          : '/';

      if (this.homeRoute === '/portal') {
        window.sessionStorage.setItem('errorHomeRoute', '/portal');
      } else {
        window.sessionStorage.removeItem('errorHomeRoute');
      }

      // Reset one-shot suppression once we are on the dedicated error page.
      if (this.isSubdomainUnavailable) {
        window.sessionStorage.removeItem('suppressGlobalErrorToast');
      }
    });
  }

}
